import { capabilityGroups } from "../data/experience";
import { referenceStudios } from "../data/site";

export default function Experience() {
  return (
    <>
      <section className="page-hero compact">
        <p className="eyebrow">Experience</p>
        <h1>Unity development, multiplayer systems, platform work, and shipping experience.</h1>
        <p>
          SZ Interactive works across gameplay, multiplayer, tools, platform integration, optimisation, deployment, and the complete process of shipping games, with practical experience across both creative and technical disciplines.
        </p>
      </section>
      <section className="section">
        <div className="section-inner experience-list">
          {capabilityGroups.map((group) => (
            <article className="experience-group" key={group.title}>
              <div>
                <p className="eyebrow">{group.title}</p>
                <h2>{group.intro}</h2>
              </div>
              <div className="badge-row large">
                {group.items.map((item) => <span className="badge" key={item}>{item}</span>)}
              </div>
            </article>
          ))}
          <article className="experience-group language">
            <div>
              <p className="eyebrow">Languages</p>
              <h2>Professional working communication in English and Turkish.</h2>
            </div>
          </article>
          <article className="experience-group">
            <div>
              <p className="eyebrow">References</p>
              <h2>Reference studios and organisations.</h2>
            </div>
            <div className="reference-list">
              {referenceStudios.map((studio) => (
                <a key={studio.href} href={studio.href} target="_blank" rel="noreferrer">
                  {studio.name}
                </a>
              ))}
            </div>
          </article>
        </div>
      </section>
    </>
  );
}
